// extracted by mini-css-extract-plugin
export var standaloneTable = "_1o-0";
export var standaloneTableWithBodyFill = "_1o-1";
export var withExtraHeader = "_1o-2";